import React, { ReactNode } from "react";

import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";

export default function BriefSection({
  briefPreview,
}: {
  briefPreview: ReactNode;
}) {
  if (!briefPreview) return null;
  return (
    <div className="create-new-project-pane__field" data-qa="campaign-brief">
      <h4 className="text-h4-regular">
        <IDHFormattedMessage id="ws_brief" defaultMessage="Brief" />
      </h4>
      {briefPreview}
    </div>
  );
}
